import { jsxs as a, Fragment as n, jsx as r } from "react/jsx-runtime";
import { Skeleton as i } from "@acctglobal/skeleton";
import { ModalHeader as m } from "../components/ModalHeader.js";
import { ModalFooter as u } from "../components/ModalFooter.js";
const f = ({
  isIO: t = !1,
  closeIOModal: o,
  genericTaggingEvent: e
}) => /* @__PURE__ */ a(n, { children: [
  t && o && /* @__PURE__ */ r(
    m,
    {
      closeModal: o,
      title: "Meus Cupons",
      genericTaggingEvent: e
    }
  ),
  /* @__PURE__ */ r(
    i,
    {
      width: t ? "100%" : "90%",
      height: t ? 600 : 425,
      backgroundColor: "var(--color-grayScale-faded)",
      margin: "auto",
      animation: !0
    }
  ),
  t && o && /* @__PURE__ */ r(
    u,
    {
      isFloating: !0,
      cancelButtonAction: o,
      cancelButtonText: "Sair"
    }
  )
] });
export {
  f as LoadingView
};
